"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonVariants = exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// packages/ui/src/Button.tsx
const react_1 = __importDefault(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
const utils_1 = require("./utils");
const buttonVariants = (0, class_variance_authority_1.cva)(
// Base classes applied to all variants
'inline-flex items-center justify-center rounded-md text-sm font-bold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-500 disabled:opacity-50 disabled:pointer-events-none', {
    variants: {
        variant: {
            primary: 'bg-brand-600 text-white hover:bg-brand-700 disabled:bg-brand-400',
            // 次要按鈕：框線樣式（§3-5 一個區塊只有一顆主要按鈕，其餘用次要）
            secondary: 'border border-slate-300 bg-transparent text-slate-800 hover:bg-slate-100 dark:border-slate-600 dark:text-slate-100 dark:hover:bg-slate-800',
            danger: 'bg-red-600 text-white hover:bg-red-700 disabled:bg-red-400',
            ghost: 'hover:bg-slate-100 text-slate-900 dark:hover:bg-slate-800 dark:text-slate-100',
            link: 'text-brand-600 underline-offset-4 hover:underline dark:text-brand-500',
        },
        size: {
            default: 'h-10 py-2 px-4',
            sm: 'h-9 px-3 rounded-md',
            lg: 'h-11 px-8 rounded-md',
        },
    },
    defaultVariants: {
        variant: 'primary',
        size: 'default',
    },
});
exports.buttonVariants = buttonVariants;
const Button = react_1.default.forwardRef(({ className, variant, size, children, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("button", { className: (0, utils_1.cn)(buttonVariants({ variant, size }), className), ref: ref, ...props, children: children }));
});
exports.Button = Button;
Button.displayName = 'Button';
